import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../../../Base/Components/BaseModal/BaseModal';
import ManagerAddWorker from './ManagerAddWorker';

interface Props extends BaseModalProps {
	onCreate: () => void;
}

const ManagerAddWorkerModal: React.FC<Props> = props => {
	return (
		<BaseModal
			{...props}
			title='component.workplaceAndWorkers.addWorkersToYourWorkplace'>
			<ManagerAddWorker onCreate={props.onCreate} />
		</BaseModal>
	);
};

export default ManagerAddWorkerModal;
